// @flow

import type {
  AuthState,
  LoginOperation,
} from '../../types'

export default function loginOperation (state: { auth: AuthState }): ?LoginOperation {
  return state.auth.loginOperation
}
